import axios from 'axios';
axios.defaults.withCredentials = true;
const FoxRequest = function (requestUrl = '', params = {}, callback = '', isPost = true, isMain = false) {
    const self = this;
    let Axios = isMain ? axios : self.$axios;
    var arr = Object.keys(params);
    if (arr.length == 0) {
        isPost = false;
    }
    if (isPost) {
        Axios.post(requestUrl, params).then(function(response){
            let data = response.data;
            if(data.error == '-4008'){
                self.$message({
                    message: data.result.message,
                    type: 'error',
                    duration: 1500,
                    onClose: function () {
                        self.$router.push("/account/login");
                        self.dialogVisible = false;
                    }
                });

                return false;
            }
            if(data.error == '-4009'){
                self.$router.push("/account/login");
                self.dialogVisible = false;
                return false;
            }
            if(typeof callback === "function"){
                callback(response);
            }
        })
    } else {
        let isParam = 0;
        if (requestUrl.indexOf('?') > -1) {
            isParam = 1;
        }
        let paramArr = [];
        for(let key in params){
            paramArr.push(key + '=' + params[key]);
        }
        if (paramArr.length > 0){
            requestUrl = requestUrl + (isParam ? '&' : '?') + paramArr.join("&");
        }
        Axios.get(requestUrl).then(function(response){
            let data = response.data;
            if(data.error == '-4008'){
                self.$message({
                    message: data.result.message,
                    type: 'error',
                    duration: 1500,
                    onClose: function () {
                        self.$router.push("/account/login");
                        self.dialogVisible = false;
                    }
                });

                return false;
            }
            if(data.error == '-4009'){
                self.$router.push("/account/login");
                self.dialogVisible = false;
                return false;
            }
            if(typeof callback === "function"){
                callback(response);
            }
        })
    }

};
export default FoxRequest;